var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loader || _vm.fullPageLoader)?_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"inava-loader"})]):_vm._e(),_c('div',{staticClass:"custom-tooltip bottom-arrow",attrs:{"id":"common-tooltip"}}),_c('div',{staticClass:"mltooltip bottom-arrow"}),_c('router-view'),_c('cookies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }